export default {
  LearnRecords_date:'YYYY年MM月',
}
